export default __webpack_public_path__ + "static/media/Ellipse 3.ed100122.png";